























import { defineComponent, ref } from '@vue/composition-api';
import sl from '@/serviceLocator';
import ProfileRow from './ProfileRow.vue';

export default defineComponent({
  components: {
    ProfileRow,
  },
  setup() {
    const store = sl.get('store');
    const { user } = store.getters;

    const firstName = ref(user ? user.firstName : '');
    const lastName = ref(user ? user.lastName : '');
    const email = ref(user ? user.email : '');

    return {
      firstName,
      lastName,
      email,
    };
  },
});
